import React, { useState, useEffect, useRef } from 'react'
import { useNavigate } from 'react-router'
import { useFetchAuthorisation, useFetchUserData } from '../../utils/AppFunctions'
import config from '../../app-config'
import { fetch_missions_by_id, create_new_mission, update_mission, delete_mission, fetch_mission_members_by_id, add_mission_member, remove_mission_member, update_mission_member } from '../../api/missionsAPI'
import { fetch_all_countries } from '../../api/countryAPI'
import { fetch_all_users_admin } from '../../api/usersAPI'
import 'react-toastify/dist/ReactToastify.css';
import AdminLayout from '../../layouts/AdminLayout'
import Switch from 'react-switch'
import Select from 'react-select'
import JoditEditor from 'jodit-react';
import notify from '../../utils/IANotification';
import ModalLayout from '../../layouts/ModalLayout';
import { MdAdd, MdDelete, MdPersonAdd, MdArrowBack, MdSave, MdPublic } from 'react-icons/md';
import { FaPrayingHands } from 'react-icons/fa';
import { fetch_all_accounts } from '../../api/accountsAPI'
import SubNavbar from '../../components/ui/SubNavbar';
import Card from '../../components/ui/Card';
import Button from '../../components/ui/Button';

export default function MissionsFormPage() {
  const navigate = useNavigate()
  useFetchAuthorisation("user")
  useFetchUserData()

  let mission_id = new URLSearchParams(window.location.search).get("mission_id")

  const [activeTab, setActiveTab] = useState("general")
  const [missionData, setMissionsData] = useState({
    country_id: "",
    title: "",
    description: "",
    start_datetime: "",
    end_datetime: "",
  })
  const [prayerListData, setPrayerListData] = useState({
    type: "mission",
    title: "",
    description: "",
    is_archived: "0",
  })
  const [prayers, setPrayers] = useState([])

  const [missionaryData, setMissionaryData] = useState([])
  const [countryData, setCountryData] = useState([])
  const [users, setUsers] = useState([])
  const [loading, setLoading] = useState(false)
  const [showMemberModal, setShowMemberModal] = useState(false)
  const [tempUserData, setTempUserData] = useState({})
  const [accountData, setAccountData] = useState([])

  let prayer_list_id = prayerListData?.id

  const tabs = [
    { id: 'general', label: 'General Info' },
    { id: 'prayers', label: 'Mission Prayers' },
    { id: 'missionaries', label: 'Missionaries & Accounts' },
  ]

  const formatDateForInput = (dateStr) => {
    if (!dateStr) return "";
    if (typeof dateStr === 'string') {
      const match = dateStr.match(/^(\d{4}-\d{2}-\d{2})/);
      if (match) return match[1];
    }
    const d = new Date(dateStr);
    if (!isNaN(d.getTime())) {
      return d.toISOString().split("T")[0];
    }
    return "";
  };

  const fetchMissionById = async () => {
    if (mission_id === "new" || !mission_id) return
    const data = await fetch_missions_by_id(mission_id)
    if (data?.status === 200) {
      setMissionsData(data.data?.mission_data)
      if (Object.keys(data.data?.prayer_list_data || {}).length > 0) {
        setPrayerListData(data.data?.prayer_list_data)
      }
      setPrayers(data.data?.prayer || [])
    }
  }

  const fetchCountries = async () => {
    const data = await fetch_all_countries();
    if (data?.status === 200) {
      setCountryData(data.data || [])
    }
  }

  const fetchAccounts = async () => {
    setLoading(true)
    const { data, error, message } = await fetch_all_accounts()
    if (error) console.log("Error fetching accounts:", message)
    setAccountData(data || [])
    setLoading(false)
  }

  useEffect(() => {
    if (mission_id !== "new") {
      fetchMissionById()
    }
    fetchCountries()
    fetchMissionary()
    fetchPlatformUsers()
    fetchAccounts()
  }, [])

  const updateMission = async () => {
    if (mission_id === "new") {
      const data = await create_new_mission(missionData)
      if (data?.status === 200) {
        notify({ type: "success", message: "Mission created successfully" })
        navigate("/admin/missions/details?mission_id=" + data.data.id)
      } else {
        notify({ type: "error", message: data?.message })
      }
    } else {
      const data = await update_mission(mission_id, missionData)
      if (data?.status === 200) {
        notify({ type: "success", message: "Mission updated successfully" })
        fetchMissionById()
        if (prayerListData?.id) updatePrayerList()
      } else {
        notify({ type: "error", message: data?.message })
      }
    }
  }

  const deleteMission = async () => {
    if (mission_id === "new" || !mission_id) return
    const data = await delete_mission(mission_id)
    if (data?.status === 200) {
      notify({ type: "success", message: "Mission deleted successfully" })
      navigate('/admin/missions')
    } else {
      notify({ type: "error", message: data?.message })
    }
  }

  const fetchMissionary = async () => {
    if (!mission_id || mission_id === "new") return
    const data = await fetch_mission_members_by_id(mission_id)
    if (data?.status === 200) {
      setMissionaryData(data.data || [])
    } else {
      notify({ message: data?.message, type: "error" })
    }
  }

  const addMember = async (member_id, role) => {
    const data = await add_mission_member({
      mission_id: mission_id,
      user_id: member_id,
      role: role
    })
    if (data?.status === 200) {
      fetchMissionary()
      notify({ message: "Missionary added", type: "success" })
    } else {
      notify({ message: data?.message, type: "error" })
    }
  }

  const removeMember = async (member_id) => {
    if (!mission_id || mission_id === "new") return
    const data = await remove_mission_member(mission_id)
    if (data?.status === 200) {
      fetchMissionary()
      notify({ message: "Missionary removed", type: "success" })
    } else {
      notify({ message: data?.message, type: "error" })
    }
  }

  const updateMember = async (member_id, role) => {
    if (!mission_id || mission_id === "new") return
    const data = await update_mission_member(mission_id, {
      user_id: member_id,
      mission_id: mission_id,
      role: role
    })
    if (data?.status === 200) {
      fetchMissionary()
      notify({ message: "Role updated", type: "success" })
    } else {
      notify({ message: data?.message, type: "error" })
    }
  }

  const fetchPlatformUsers = async () => {
    setLoading(true)
    const data = await fetch_all_users_admin()
    if (data?.status === 200) {
      setUsers(data.data || [])
    }
    setLoading(false)
  }

  const savePrayerList = async () => {
    setLoading(true)
    let endpoint = config.endpoint + "/prayer/list"
    let response = await fetch(endpoint, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify({
        ...prayerListData,
        prayers,
        mission_id
      })
    })
    let data = await response.json()
    if (data.status === 200) {
      fetchMissionById()
      notify({ type: "success", message: "Prayer list created" })
    } else {
      notify({ type: "error", message: "Failed to save prayer list" })
    }
    setLoading(false)
  }

  const updatePrayerList = async () => {
    if (!prayerListData?.id) return
    setLoading(true)
    let endpoint = config.endpoint + "/prayer/list/id/" + prayer_list_id
    let response = await fetch(endpoint, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify({
        ...prayerListData,
        prayers
      })
    })
    let data = await response.json()
    if (data.status === 200) {
      fetchMissionById()
      notify({ type: "success", message: "Updated prayer list" })
    } else {
      notify({ type: "error", message: "Failed to update prayer list" })
    }
    setLoading(false)
  }

  const ROLES = [
    { value: 0, label: "Missionary" },
    { value: 1, label: "Treasurer" },
    { value: 2, label: "Leader" },
  ]

  return (
    <AdminLayout
      navSelected={"Missions"}
      headerText={mission_id === "new" ? "New Mission Trip" : "Edit Mission Trip"}
      toolbar={
        <>
          <div className="flex items-center gap-3">
            <Button variant="outline" icon={MdArrowBack} onClick={() => navigate('/admin/missions')}>
              Back
            </Button>
            <h1 className='text-xl font-bold text-gray-900'>
              {mission_id === "new" ? "Create Mission" : missionData.title || "Edit Mission"}
            </h1>
          </div>
          <div className='flex gap-2'>
            {mission_id !== "new" && (
              <Button variant="danger" icon={MdDelete} onClick={deleteMission}>
                Delete
              </Button>
            )}
            <Button variant="primary" icon={MdSave} onClick={updateMission}>
              {mission_id === "new" ? "Create" : "Save Changes"}
            </Button>
          </div>
        </>
      }
    >
      <SubNavbar
        tabs={tabs}
        activeTab={activeTab}
        onTabChange={setActiveTab}
      />

      {/* Add User Modal */}
      <ModalLayout isVisible={showMemberModal} setIsVisible={setShowMemberModal} modalTitle="Add Missionary to Mission">
        <div className="space-y-4">
          <div className="input-container">
            <label className="input-label font-semibold">Select User</label>
            <Select
              options={users.map(user => ({ label: user.first_name + " " + user.last_name, value: user.id }))}
              onChange={(e) => setTempUserData(e)}
            />
          </div>
          <div className="input-container">
            <label className="input-label font-semibold">Assigned Role</label>
            <Select
              options={ROLES}
              onChange={(e) => setTempUserData({ ...tempUserData, role: e.value })}
            />
          </div>
          <div className="flex justify-end pt-2">
            <Button variant="primary" icon={MdAdd} onClick={() => {
              addMember(tempUserData.value, tempUserData.role)
              setShowMemberModal(false)
            }}>
              Add Missionary
            </Button>
          </div>
        </div>
      </ModalLayout>

      {/* TAB 1: GENERAL INFO */}
      {activeTab === "general" && (
        <Card title="Mission Trip Profile" subtitle="Title, country, schedule dates, and overview description.">
          <div className="space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="input-container">
                <label className="input-label font-semibold">Mission Name / Title</label>
                <input
                  type="text"
                  className="text-input"
                  value={missionData?.title || ""}
                  onChange={(e) => setMissionsData({ ...missionData, title: e.target.value })}
                  placeholder='e.g. Seekers Baray Mission Trip'
                />
              </div>

              <div className="input-container">
                <label className="input-label font-semibold">Target Country</label>
                <Select
                  options={countryData.map((country) => ({
                    value: country?.altSpellings?.[0],
                    label: country.name
                  }))}
                  value={countryData.map((country) => ({
                    value: country?.altSpellings?.[0],
                    label: country.name
                  })).find((c) => c.value == missionData?.country_id)}
                  onChange={(e) => setMissionsData({ ...missionData, country_id: e.value })}
                />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="input-container">
                <label className="input-label font-semibold">Start Date</label>
                <input
                  type="date"
                  className="text-input"
                  value={formatDateForInput(missionData?.start_datetime)}
                  onChange={(e) => setMissionsData({ ...missionData, start_datetime: e.target.value })}
                />
              </div>

              <div className="input-container">
                <label className="input-label font-semibold">End Date</label>
                <input
                  type="date"
                  className="text-input"
                  value={formatDateForInput(missionData?.end_datetime)}
                  onChange={(e) => setMissionsData({ ...missionData, end_datetime: e.target.value })}
                />
              </div>
            </div>

            <div className="input-container">
              <label className="input-label font-semibold">Mission Description</label>
              <textarea
                className="textarea-input h-36"
                value={missionData?.description || ""}
                placeholder="Overview of the mission field, objectives, and activities..."
                onChange={(e) => setMissionsData({ ...missionData, description: e.target.value })}
              />
            </div>
          </div>
        </Card>
      )}

      {/* TAB 2: MISSION PRAYERS */}
      {activeTab === "prayers" && (
        <Card
          title="Mission Prayer Requests &amp; Testimonies"
          subtitle="Manage prayer points for congregation intercession."
          headerRight={
            <Button
              variant="secondary"
              size="sm"
              icon={MdAdd}
              onClick={() => setPrayers([...prayers, { content: "", is_archived: "0", is_answered: "0", user_id: "", prayer_list_id: "", can_repeat: "0", prayers_count: [], testimony: "" }])}
            >
              Add Prayer
            </Button>
          }
        >
          {mission_id === "new" ? (
            <p className="text-xs text-gray-400 italic py-6 text-center">Save the mission profile first before configuring prayer requests.</p>
          ) : (
            <div className="space-y-6">
              {!prayerListData?.id && (
                <div className="flex flex-col items-center justify-center p-8 bg-gray-50 rounded-2xl border border-gray-200 text-center space-y-3">
                  <p className="text-sm font-semibold text-gray-700">No prayer list currently associated with this mission.</p>
                  <Button variant="primary" icon={MdAdd} onClick={savePrayerList}>
                    Create Prayer List
                  </Button>
                </div>
              )}

              {prayers.length > 0 ? (
                <div className="space-y-4">
                  {prayers.map((prayer, index) => (
                    <div key={index} className="p-5 bg-gray-50 rounded-2xl border border-gray-200 space-y-4">
                      <div className="flex items-center justify-between">
                        <span className="font-bold text-xs text-gray-900">Prayer Request #{index + 1}</span>
                        <div className="flex items-center gap-3">
                          <span className="flex items-center gap-1 text-xs text-gray-500 font-semibold">
                            <FaPrayingHands /> {prayer.prayers_count?.length || 0} intercessors
                          </span>
                          <Button
                            variant="danger"
                            size="sm"
                            icon={MdDelete}
                            onClick={() => {
                              let newPrayers = [...prayers]
                              newPrayers.splice(index, 1)
                              setPrayers(newPrayers)
                            }}
                          >
                            Delete
                          </Button>
                        </div>
                      </div>

                      <div className="input-container">
                        <label className="input-label font-semibold">Prayer Request Content</label>
                        <textarea
                          className="textarea-input h-20"
                          value={prayer.content || ""}
                          onChange={(e) => {
                            let newPrayers = [...prayers]
                            newPrayers[index].content = e.target.value
                            setPrayers(newPrayers)
                          }}
                        />
                      </div>

                      <div className="flex items-center gap-6 pt-2">
                        <div className="flex items-center gap-2">
                          <Switch
                            checked={prayer.is_answered == "1"}
                            onChange={(checked) => {
                              let newPrayers = [...prayers]
                              newPrayers[index].is_answered = checked ? "1" : "0"
                              setPrayers(newPrayers)
                            }}
                          />
                          <span className="text-xs font-semibold text-gray-700">Answered Prayer</span>
                        </div>

                        <div className="flex items-center gap-2">
                          <Switch
                            checked={prayer.can_repeat == "1"}
                            onChange={(checked) => {
                              let newPrayers = [...prayers]
                              newPrayers[index].can_repeat = checked ? "1" : "0"
                              setPrayers(newPrayers)
                            }}
                          />
                          <span className="text-xs font-semibold text-gray-700">Repeatable</span>
                        </div>
                      </div>

                      {prayer.is_answered == "1" && (
                        <div className="input-container">
                          <label className="input-label font-semibold">Praise Testimony</label>
                          <textarea
                            className="textarea-input h-20"
                            value={prayer.testimony || ""}
                            placeholder="Share testimony of how God answered this prayer..."
                            onChange={(e) => {
                              let newPrayers = [...prayers]
                              newPrayers[index].testimony = e.target.value
                              setPrayers(newPrayers)
                            }}
                          />
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              ) : (
                <p className="text-xs text-gray-400 italic py-4">No prayer requests added yet.</p>
              )}
            </div>
          )}
        </Card>
      )}

      {/* TAB 3: MISSIONARIES & ACCOUNTS */}
      {activeTab === "missionaries" && (
        <div className="space-y-6">
          <Card title="Financial Account Link" subtitle="Associated ledger account for mission funds.">
            <div className="input-container max-w-md">
              <label className="input-label font-semibold">Account Ledger</label>
              <Select
                options={accountData.map((account) => ({ value: account.id, label: account.name }))}
                value={accountData.map((account) => ({ value: account.id, label: account.name })).find((account) => account.value == missionData?.account_id)}
                onChange={(e) => setMissionsData({ ...missionData, account_id: e.value })}
              />
            </div>
          </Card>

          <Card
            title="Assigned Missionaries &amp; Team"
            subtitle="Personnel serving on this mission trip."
            headerRight={
              mission_id !== "new" && (
                <Button variant="primary" size="sm" icon={MdPersonAdd} onClick={() => setShowMemberModal(true)}>
                  Add Missionary
                </Button>
              )
            }
          >
            {mission_id === "new" ? (
              <p className="text-xs text-gray-400 italic py-6 text-center">Save mission profile first before adding missionaries.</p>
            ) : missionaryData?.length > 0 ? (
              <div className="space-y-3">
                {missionaryData.map((member, index) => (
                  <div key={index} className="flex flex-col sm:flex-row sm:items-center justify-between p-3.5 bg-gray-50 rounded-xl border border-gray-200 gap-3">
                    <span
                      onClick={() => navigate("/admin/users/details?user_id=" + member.user_id)}
                      className='font-bold text-xs text-blue-600 cursor-pointer hover:underline'
                    >
                      {member?.user_data?.first_name} {member?.user_data?.last_name}
                    </span>

                    <div className="flex items-center gap-3">
                      <div className="w-40">
                        <Select
                          options={ROLES}
                          value={ROLES.find(role => role.value == member.role)}
                          onChange={(e) => updateMember(member.user_id, e.value)}
                        />
                      </div>
                      <Button variant="danger" size="sm" icon={MdDelete} onClick={() => removeMember(member.user_id)}>
                        Remove
                      </Button>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <p className="text-xs text-gray-400 italic py-4">No missionaries added yet.</p>
            )}
          </Card>
        </div>
      )}
    </AdminLayout>
  )
}
